import
{
    SURVEYACTIVITYV3SCREEN_LOAD,
    SURVEYACTIVITYV3SCREEN_UNLOAD,
    SURVEYACTIVITYV3SCREEN_SET,
} from '../../../actionDefinitions';
import { createReducer } from '../../../reducerUtils';

const initialState =
{
    //ticketCountOverTimeStats
};

const handlers = {
    [SURVEYACTIVITYV3SCREEN_LOAD]: (state, action) =>
    {
        if (action.error)
        {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [SURVEYACTIVITYV3SCREEN_UNLOAD]: () => initialState,
    [SURVEYACTIVITYV3SCREEN_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
